export const removeEmptyObject = (obj: any) => {
    Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'string') {
            obj[key] = obj[key].trim();
        }
        if (obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
        if (obj[key] === '') {
            obj[key] = null;
        }
    });
    return obj;
};
